import { render, staticRenderFns } from "./Alumni.vue?vue&type=template&id=21bb8f10&scoped=true&"
import script from "./Alumni.vue?vue&type=script&lang=js&"
export * from "./Alumni.vue?vue&type=script&lang=js&"
import style0 from "./Alumni.vue?vue&type=style&index=0&id=21bb8f10&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21bb8f10",
  null
  
)

export default component.exports